export default __webpack_public_path__ + "assets/eb53e078d9a7b5b04361d34c4cd873f7.png";